import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://service.betacloud.online/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Customer API
export const customerAPI = {
  search: async (query) => {
    const response = await api.get(`/notion/search-customer?query=${encodeURIComponent(query)}`);
    return response.data;
  },
  
  create: async (customerData) => {
    const response = await api.post('/notion/create-customer', customerData);
    return response.data;
  },
  
  update: async (customerData) => {
    const response = await api.put('/notion/update-customer', customerData);
    return response.data;
  },
};

// Protocol API
export const protocolAPI = {
  create: async (protocolData) => {
    const response = await api.post('/protocols', protocolData);
    return response.data;
  },
  
  preview: async (protocolData) => {
    const response = await api.post('/protocols/preview', protocolData);
    return response.data;
  },
  
  getPDF: (pdfId) => {
    return `${API_URL}/protocols/preview/${pdfId}`;
  },
  
  list: async (skip = 0, limit = 10) => {
    const response = await api.get(`/protocols?skip=${skip}&limit=${limit}`);
    return response.data;
  },
  
  delete: async (protocolId) => {
    const response = await api.delete(`/protocols/${protocolId}`);
    return response.data;
  },
  
  deleteAll: async () => {
    const response = await api.delete('/protocols/delete-all');
    return response.data;
  },
  
  resendEmail: async (protocolId, email) => {
    const response = await api.post(`/protocols/${protocolId}/resend-email`, { email });
    return response.data;
  },
};

// Settings API
export const settingsAPI = {
  getSMTP: async () => {
    const response = await api.get('/smtp-settings');
    return response.data;
  },
  
  saveSMTP: async (smtpData) => {
    const response = await api.post('/smtp-settings', smtpData);
    return response.data;
  },
  
  testSMTP: async (smtpData) => {
    const response = await api.post('/test-smtp', smtpData);
    return response.data;
  },
};

// User API
export const userAPI = {
  list: async () => {
    const response = await api.get('/auth/users');
    return response.data;
  },
  
  create: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },
  
  delete: async (username) => {
    const response = await api.delete(`/auth/users/${username}`);
    return response.data;
  },
};

export default api;
